<template>
    <internal>
        <div class="p-6 bg-white border-b border-gray-200 overflow-hidden shadow-sm sm:rounded-lg">
            <breeze-table :searchable="true" :fields="fields" :items="_admissions" :courses="courses"
                          :searchlink="route('internal.kt-students.search',branchId)"
                          :canView="$page.props.auth.user.role.permissions.find(permission => permission.name === 'View KT Students')">
                <template #course_code="data">
                    {{ data.item.course.code }}
                </template>
                <template #roll_no="data">
                    {{ data.item.roll_no }}
                </template>
                <template #student_name="data">
                    {{ data.item.student.first_name }} {{ data.item.student.last_name }}
                </template>
                <template #year="data">
                    {{ data.item.courseyear.title }}
                </template>
                <template #action_buttons>
                    <a :href="route('internal.kt-students.export',{branch:branchId})" class="bg-gray-800 inline-flex items-center px-4 py-2  border border-transparent
    rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700
    active:bg-gray-900 focus:outline-none disabled:cursor-not-allowed
     focus:border-gray-900 focus:shadow-outline-gray transition ease-in-out duration-150">Export Excel</a>
                    <BreezeButton @click="_importModal = true">Import Excel</BreezeButton>
                </template>
            </breeze-table>
        </div>

        <Model :is-open="_importModal" custom-classes="max-w-md">
            <template #body>
                <div>
                    <div class="flex justify-between items-center">
                        <p class="font-medium">Import KT Students Excel</p>
                    </div>
                    <div class="items-center justify-between w-full mt-6 space-x-6 md:flex">
                        <input
                            class="w-full mt-1 mb-2 md:mb-0 ring-primary"
                            type="file"
                            required
                            accept=".xls,.xlsx"
                            @change="filePicked"
                        />
                    </div>

                    <breeze-input-error :message="form.errors.doc?form.errors.doc:''"/>
                </div>
            </template>
            <template #buttons>
                <div class="flex justify-end">
                    <div class="flex justify-end space-x-4">
                        <BreezeButton @click="_importModal =false" class="bg-red-600 hover:bg-red-600 focus:bg-red-600">
                            Close
                        </BreezeButton>
                        <BreezeButton @click="importFile">Submit</BreezeButton>
                    </div>
                </div>
            </template>
        </Model>
    </internal>
</template>

<script setup>
import Internal from '@/Pages/Internal/Internal'
import BreezeTable from '@/Components/Table'
import BreezeButton from "@/Components/Button";
import {computed, ref, watch} from "vue";
import {useForm} from "@inertiajs/inertia-vue3";
import Model from "@/Components/Model.vue";
import BreezeInputError from '@/Components/InputError'
import ButtonLink from '@/Components/ButtonLink'

const props = defineProps({
    admissions: {
        type: Array,
    },
    courses: {
        type: Array,
    }
})

const fields = [
    {'key': 'course_code', 'label': 'Course Code'},
    {'key': 'roll_no', 'label': 'Roll No'},
    {'key': 'student_name', 'label': 'Student Name'},
    {'key': 'year', 'label': 'Year'},
    {'key': 'kt_subjects', 'label': 'KT Subjects'}
];

const _importModal = ref(false);
const branchId = computed(() => localStorage.branchId);
const _admissions = ref(props.admissions);

const form = useForm({
    doc: ""
});

function filePicked(e) {
    form.doc = e.target.files[0]
}

function importFile() {
    form.post(route("internal.kt-students.import", {branch: branchId.value}), {
        preserveState: true,
        onSuccess: (res) => {
            _importModal.value = false;
            _admissions.value = res.props.admissions;
        },
    });
}


watch(_importModal, () => {
    form.clearErrors();
    form.reset();
})


</script>
